import { MEDIA } from 'StateEvents';
import { emitMethod, update } from 'Emitter';
import Throttleable from 'Services/Behaviors/Throttleable';

export default class Handler extends Throttleable {
  constructor(options) {
    super();
    
    if(!options.src) {
      throw new Error('media source undefined');
    }
    
    this.src = options.src;
    this.mime = options.mime;
    emitMethod(this, MEDIA.COMPLETE,        'onEnded');
    emitMethod(this, MEDIA.STARTED,         'onStarted');
    emitMethod(this, MEDIA.TIME_UPDATE,     'onTimeUpdate');
    emitMethod(this, MEDIA.DURATION_CHANGE, 'onDurationChange');
    this.ready = false;
  }

  play() {}

  start() {
    this.play();
    update(MEDIA.STARTED, 'start');
  }

  configure(videoEl) {
    return Promise.resolve(this);
  }

  setVolume(volume) {}
  resize(width, height, mode) {}
}


// WEBPACK FOOTER //
// ./src/Media/Handlers/Handler.js